module.exports = __webpack_public_path__ + "img/twitter-tweet-1.b5bdc83e.jpeg";